exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-790cc16b]{height:calc(100vh - 210px);overflow-y:scroll}[data-v-790cc16b] .el-drawer__body{height:100%;overflow-y:auto}\n", ""]);

// exports
